var a = Object.defineProperty, n = Object.getOwnPropertySymbols, p = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable, l = (t, r, e) => r in t ? a(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e, f = (t, r) => {
  for (var e in r || (r = {}))
    p.call(r, e) && l(t, e, r[e]);
  if (n)
    for (var e of n(r))
      c.call(r, e) && l(t, e, r[e]);
  return t;
};
function i(t, r) {
  if (r === null || typeof r != "object")
    return {};
  const e = f({}, r);
  return Object.keys(r).forEach((o) => {
    o.includes(`${String(t)}.`) && delete e[o];
  }), e;
}
export {
  i as clearListState
};
